import React from 'react';
import type ServicedeskKnowledgeArticleEmbedEditorType from '@atlassian/jira-spa-apps-servicedesk-knowledge-article-embed-editor/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServiceDeskKnowledgeArticleEmbedEditor = lazyForPaint<
	typeof ServicedeskKnowledgeArticleEmbedEditorType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-embed-editor", jiraSpaEntry: "async-servicedesk-knowledge-hub-embed-editor" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-article-embed-editor'
		),
	),
);

const AsyncServiceDeskKnowledgeArticleEmbedEditor = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServiceDeskKnowledgeArticleEmbedEditor}
		pageId="knowledge-article-embed-editor"
		shouldShowSpinner
	/>
);

export default AsyncServiceDeskKnowledgeArticleEmbedEditor;
